import { ProfilePhotoModel } from '@vp/profile/core/model/ProfilePhotoModel';

export abstract class SlideshowMediaLoader {
  abstract loadImages(images: ProfilePhotoModel[]): Promise<ProfilePhotoModel[]>;
  abstract loadAudio(audioUrl: string): Promise<Blob>;
}
